export interface DisposableEmailResponse {
  format?: boolean;
  alias?: boolean;
  domain?: string;
  disposable?: boolean;
  dns?: boolean;
}

export const isEmailFromWhitelistedDomains = (email: string) =>
  ['gmail.com', 'hotmail.com', 'yahoo.com'].some((domainName) => email.endsWith(domainName));

export const handleDisposableEmail = async (email: string) => {
  // For test case :/ -> Allow up2rent+XXX@mailsac.com
  if (/^up2rent\+([^\s@]+)@mailsac.com$/.test(email)) {
    return {
      disposable: false,
      dns: true,
    };
  }
  try {
    const response = await fetch(`https://disify.com/api/email/${email}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });
    const data: DisposableEmailResponse = (await response.json()) as DisposableEmailResponse;

    return data;
  } catch (err) {
    console.log(err);
  }
  return undefined;
};
